import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: stretch;
  margin-left: 6rem;

  color: var(--text-quarterly);
`;
